import { DEAL_INFO_TYPES } from '@wix/wix-vod-constants/common';
import { minBy } from 'lodash';
export function getMinPriceInfo(dealInfo) {
  const enabledDealInfo = (dealInfo || []).filter(d => d.enabled);
  if (!enabledDealInfo.length) {
    return null;
  }
  return minBy(enabledDealInfo, 'price');
}
export function hasEnabledPriceInfo(dealInfo) {
  return (dealInfo || []).some(d => d.enabled);
}
function buildGetPriceInfo(type) {
  return dealInfo => {
    return (dealInfo || []).find(d => d.enabled && d.type === type) || null;
  };
}
export const getSubscriptionPriceInfo = buildGetPriceInfo(DEAL_INFO_TYPES.SUBSCRIPTION);
export const getSalePriceInfo = buildGetPriceInfo(DEAL_INFO_TYPES.SALE);
export const getRentPriceInfo = buildGetPriceInfo(DEAL_INFO_TYPES.RENT);
export const getPricingPlanInfo = buildGetPriceInfo(DEAL_INFO_TYPES.PLAN);
export function getDealInfoByType(dealInfo, type) {
  switch (type) {
    case DEAL_INFO_TYPES.SALE:
      return getSalePriceInfo(dealInfo);
    case DEAL_INFO_TYPES.RENT:
      return getRentPriceInfo(dealInfo);
    case DEAL_INFO_TYPES.SUBSCRIPTION:
      return getSubscriptionPriceInfo(dealInfo);
    case DEAL_INFO_TYPES.PLAN:
      return getPricingPlanInfo(dealInfo);
    default:
      return {};
  }
}
//# sourceMappingURL=deal-info-helpers.js.map